import styled from "@emotion/styled";
import Alert from "shared/components/Alert";

export const StyledAlert = styled(Alert)`
  position: absolute;
  right: 24px;
  bottom: 4px;
  width: 360px;
`;

export const StyledHeaderCell = styled('strong')`
  width: 100%;
`;